<template><div><h1 id="_3-eloqua-marketing-automation" tabindex="-1"><a class="header-anchor" href="#_3-eloqua-marketing-automation"><span>3. Eloqua (Marketing Automation)</span></a></h1>
<p>Zum Marketing Automation-Tool Eloqua von Oracle bietet funtrade eine Schnittstelle für die Synchronisierung der Daten.</p>
<p>Die Synchronisierung beinhaltet zur Zeit folgende Bereiche:</p>
<ul>
<li>
<p>Personen</p>
</li>
<li>
<p>Publikationen</p>
</li>
<li>
<p>Merkmale</p>
</li>
</ul>
<p>Die versendeten E-Mails aus Eloqua, sowie auch E-Mail Bounces werden in funtrade bei den Personen als Ereignisse (Kontaktgeschichte) abgebildet.</p>
<h3 id="_3-1-parametrisierung" tabindex="-1"><a class="header-anchor" href="#_3-1-parametrisierung"><span>3.1. Parametrisierung</span></a></h3>
<p>Die Parametrisierung erfolgt anhand der Definition in den Tabellen <RouteLink to="/referenz/refs/ft.refdata.tblpubl.html">Publikationen</RouteLink> und <RouteLink to="/referenz/refs/ft.refdata.tbladrmerkmal.html">Merkmale</RouteLink> durch das Attribut &quot;Eloqua&quot;, sowie die notwendigen Einstellungen in den Zuordnungstabellen <RouteLink to="/referenz/refs/ft.refdata.EloquaPubZuordnung.html">Publikationen</RouteLink> und <RouteLink to="/referenz/refs/ft.refdata.EloquaEmailVersandZuordnung.html">E-Mailversand</RouteLink> .</p>
<h4 id="_3-1-1-personen" tabindex="-1"><a class="header-anchor" href="#_3-1-1-personen"><span>3.1.1. Personen</span></a></h4>
<p>Es werden nicht alle Personen mit Eloqua synchronisiert. Die zu synchronisierenden Personen erfolgt aufgrund des Attributs &quot;Eloqua&quot; in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.tblpubl.html">Publikationen</RouteLink> . Das bedeutet, es werden nur Personen mit Eloqua synchronisiert, die eine Publikation mit dem Attribut &quot;Eloqua&quot; aufweisen.</p>
<p>Nachfolgend eine Liste mit den für die Synchronisierung vorgesehenen Felder:</p>
<table>
<thead>
<tr>
<th>Feldname für die Schnittstelle</th>
<th>Feldname                   in funtrade</th>
<th>Bezeichnung/Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>idFuntrade</td>
<td>adrnum</td>
<td>Personennummer</td>
</tr>
<tr>
<td>contactType</td>
<td>adresstyp</td>
<td>Personentyp</td>
</tr>
<tr>
<td>gender</td>
<td>gescode</td>
<td>Geschlecht</td>
</tr>
<tr>
<td>language</td>
<td>sprache</td>
<td>Sprache</td>
</tr>
<tr>
<td>dateOfBirth</td>
<td>gebdat</td>
<td>Geburtsdatum</td>
</tr>
<tr>
<td>yearOfBirth</td>
<td>gebjah</td>
<td>Geburtsjahr</td>
</tr>
<tr>
<td>firstName</td>
<td>vname</td>
<td>Vorname</td>
</tr>
<tr>
<td>lastName</td>
<td>name1</td>
<td>Nachname</td>
</tr>
<tr>
<td>company</td>
<td>firma</td>
<td>Organisation</td>
</tr>
<tr>
<td>inFuntradeCreatedBy</td>
<td>anid</td>
<td>Benutzer der den Datensatz erfasst hat</td>
</tr>
<tr>
<td>inFuntradeCreatedAt</td>
<td>andat</td>
<td>Datensatz erfasst am</td>
</tr>
<tr>
<td>inFuntradeModifiedBy</td>
<td>mutid</td>
<td>Benutzer der den Datensatz editiert hat</td>
</tr>
<tr>
<td>inFuntradeModifiedAt</td>
<td>mutdat</td>
<td>Datensatz editiert am</td>
</tr>
<tr>
<td>mobilePhone</td>
<td>mobile</td>
<td>Mobilenummer</td>
</tr>
<tr>
<td>phone</td>
<td>anruf</td>
<td>Festnetznummer</td>
</tr>
<tr>
<td>addressSupplement</td>
<td>name2</td>
<td>Adresszusatz</td>
</tr>
<tr>
<td>street</td>
<td>strasse</td>
<td>Strasse</td>
</tr>
<tr>
<td>streetNumber</td>
<td>hausnum</td>
<td>Hausnummer</td>
</tr>
<tr>
<td>poBox</td>
<td>postfachplusnr</td>
<td>Postfach</td>
</tr>
<tr>
<td>zipOrPostalCode</td>
<td>plz</td>
<td>Postleitzahl</td>
</tr>
<tr>
<td>city</td>
<td>ort</td>
<td>Ort</td>
</tr>
<tr>
<td>stateOfProvince</td>
<td>kanton</td>
<td>Kanton</td>
</tr>
<tr>
<td>country</td>
<td>land</td>
<td>Land</td>
</tr>
<tr>
<td>salutationEmail</td>
<td>briefanrede</td>
<td>Briefanrede</td>
</tr>
<tr>
<td>address1</td>
<td>adresszeilen</td>
<td>Adresszeile</td>
</tr>
<tr>
<td>personLocked</td>
<td>sperrperson</td>
<td>Personensperre</td>
</tr>
<tr>
<td>postWelcome</td>
<td>nosperrpost</td>
<td>Kanal Post</td>
</tr>
<tr>
<td>callWelcome</td>
<td>nosperranruf</td>
<td>Kanal Anruf</td>
</tr>
<tr>
<td>smsWelcome</td>
<td>nosperrsms</td>
<td>Kanal SMS</td>
</tr>
</tbody>
</table>
<h4 id="_3-1-2-publikationen" tabindex="-1"><a class="header-anchor" href="#_3-1-2-publikationen"><span>3.1.2. Publikationen</span></a></h4>
<p>Es werden nicht alle Publikationen mit Eloqua synchronisiert. Die zu synchronisierenden Publikationen erfolgt aufgrund des Attributs &quot;Eloqua&quot; in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.tblpubl.html">Publikationen</RouteLink> . Das bedeutet, es werden nur die Publikationen mit Eloqua synchronisiert, die das Attribut &quot;Eloqua&quot; aufweisen.</p>
<h4 id="_3-1-3-merkmale" tabindex="-1"><a class="header-anchor" href="#_3-1-3-merkmale"><span>3.1.3. Merkmale</span></a></h4>
<p>Es werden nicht alle Merkmale mit Eloqua synchronisiert. Die zu synchronisierenden Merkmale erfolgt aufgrund des Attributs &quot;Eloqua&quot; in der Tabelle <RouteLink to="/referenz/refs/ft.refdata.tbladrmerkmal.html">Merkmale</RouteLink> . Das bedeutet, es werden nur die Merkmale mit Eloqua synchronisiert, die das Attribut &quot;Eloqua&quot; aufweisen.</p>
</div></template>


